import { render, staticRenderFns } from "./WidgetContractLimits.vue?vue&type=template&id=2a79dfd5"
import script from "./WidgetContractLimits.vue?vue&type=script&lang=ts"
export * from "./WidgetContractLimits.vue?vue&type=script&lang=ts"
import style0 from "./WidgetContractLimits.vue?vue&type=style&index=0&id=2a79dfd5&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports